import structure from "./action-types";
import axios from "axios";
import { showSuccess, showError } from "../../app/toastify";

import commonTypes from "../common/action-types";
import { isSessionExpired } from "../common/actions";

const types = { ...commonTypes, ...structure };

export const getRegisteredUnemployedPeople = (
  query,
  setTotalItems,
  setLoader,
) => {
  return async (dispatch) => {
    try {
      setLoader(true);

      const { data } = await axios.get(
        "/api/unemployed-people" + "?" + new URLSearchParams(query).toString(),
      );

      dispatch({
        type: types.SET_REGISTERED_UNEMPLOYED_PEOPLE,
        data: data.records,
      });

      setTotalItems(data.totalRecords);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};
